import React, { Component } from "react";
import '../../../assets/css/question.css';
import '../../../assets/css/custom.css';
import '../../../assets/css/new_style.css';
import CheifComplain from './CheifComplain';
import CheifComplainLocation from './CheifComplainLocation';
import Questions from "./Questions";
import PatientResponse from "./PatientResponse";
import {SURGEON} from '../../../services/Surgeon';
import PatientNarrative from "./PatientNarrative";
import { CONFIG,checkAuth,getLoggedInData } from '../../../helpers/Common';
import IdleTimer from 'react-idle-timer'

class SurgeonModifyComplain extends Component {
    constructor(props)
    {
        super(props);
        if(this.props.profileData=="")
        {
            window.location.replace('/')
        }
        this.state = {
            next:1,
            prev:0,
            profileData:'',
            complainData:'',
            complainLocation:'',
            questionAnswersData: [],
            responseData: '',
            narrativeSummary: '',
            checkedItems: new Map(),
            isNarrativeUpdate: false,
            surgeon_id: '',
            narrative_id: '',
            optionInputFields:new Array(),
            showInput:'',
            isLoading: true,
            selectedComplains: new Array(),
            addAnotherComplain:false,
            patientAdditionalInfo: '',
            allComplains:[],
            questionAnswersResponse:null

        };
        this.handleNextPrevSteps        = this.handleNextPrevSteps.bind(this)
        this.setProfileData             = this.setProfileData.bind(this)
        this.setComplainData            = this.setComplainData.bind(this)
        this.setComplainLocationData    = this.setComplainLocationData.bind(this)
        this.setResponseData            = this.setResponseData.bind(this)
        this.setNarrativeSummary        = this.setNarrativeSummary.bind(this)
        this.setAllComplains            = this.setAllComplains.bind(this)
        this.setCheckedItems            = this.setCheckedItems.bind(this)
        this.setIsNarrativeUpdate       = this.setIsNarrativeUpdate.bind(this)
        this.setSelectedComplains       = this.setSelectedComplains.bind(this)
        this.checkAuth                  = checkAuth();//
        this.getLoggedInData            = getLoggedInData();//
        this.getPatientId               = this.getPatientId.bind(this)
        this.setNarrativeId             = this.setNarrativeId.bind(this)
        this.setQuestionAnswersResponse = this.setQuestionAnswersResponse.bind(this);


        this.getLoggedInData            = getLoggedInData.bind(this)// Import from common
        this.checkAuth                  = checkAuth.bind(this)// Import from common
        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
    }
    componentWillMount() {

        checkAuth();
        let userData = getLoggedInData();
        this.setState({
            surgeon_id: userData.user_id
        });
        this.handleNextPrevSteps(2);
        let id  = this.props.location.pathname.split('/');
        id      = id[(id.length)-1];
        this.setState({
            patientId:id
        });
        let patientDetails = SURGEON.getPatientDetail(id).then(res => {
            if(res.data.header.error==0)
            {
                let data       = res.data.body.details;
                this.setState({
                    profileData: data,
                    isLoading: false,
                    patientAdditionalInfo:data.patient_additional_info,
                    allComplains:JSON.parse(this.props.location.state.patientData.all_complaints)
                });
            }
            if(res.data.header.error==400)
            {
                this.props.history.push('/surgeon/login');
            }
        }).catch(err => {
            return err;
        });

    }

    setQuestionAnswersResponse(response){

        this.setState({...this.state,questionAnswersResponse: response});
    }

    //Clear local storage on close and timeout
    _onIdle(e) {
        localStorage.removeItem('data');
        localStorage.removeItem('patientProfile');
        window.location.reload();
    }
    componentDidMount() {
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            localStorage.removeItem('data');
            localStorage.removeItem('patientProfile');
            window.location.reload();
        });
    }

    render() {
        return (
            <React.Fragment>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onIdle={this.onIdle}
                    debounce={250}
                    timeout={1000 * 60 * CONFIG.IdleTimeOut} />
                {this.state.next === 2 &&
                    <CheifComplain
                        next={this.state.next}
                        prev={this.state.prev}
                        handleNextPrevSteps={this.handleNextPrevSteps}
                        getComplainData={this.state.complainData}
                        profileData={this.state.profileData}
                        setComplainLocation={this.setComplainLocationData}
                        setComplainData={this.setComplainData}
                        getSelectedComplainData={this.state.selectedComplains}
                        patientId={this.state.patientId}
                        isModify={true}
                    />
                }
                {this.state.next === 3 && this.state.complainData!=='' && this.state.complainData.complainTypeDetails.image_front !== '' &&
                <CheifComplainLocation
                    next={this.state.next}
                    prev={this.state.prev}
                    isComplainMaster={false}
                    profileData={this.state.profileData}
                    handleNextPrev={this.handleNextPrevSteps}
                    getComplainData={this.state.complainData}
                    setComplainLocation={this.setComplainLocationData}
                    getComplainLocationData={this.state.complainLocationData}
                    patientId={this.state.patientId}
                    isModify={true}
                    setNarrativeId={this.setNarrativeId}
                />
                }

                {this.state.next === 3 && this.state.complainData!=='' && this.state.complainData.complainTypeDetails.image_front === '' &&
                <Questions
                    next={this.state.next}
                    prev={this.state.prev}
                    isAddComplain={false}
                    handleNextPrevSteps={this.handleNextPrevSteps}
                    handleNextPrevSteps={this.handleNextPrevSteps}
                    getComplainData={this.state.complainData}
                    setQuestionAnswersData={this.setQuestionAnswersData}
                    setCheckedItems={this.setCheckedItems}
                    checkedItems={this.state.checkedItems}
                    questionAnswersData={this.state.questionAnswersData}
                    isNarrativeUpdate={this.state.isNarrativeUpdate}
                    optionInputFields={this.state.optionInputFields}
                    showInput={this.state.showInput}
                    setOptionInputFields={this.setOptionInputFields}
                    setInputField={this.setShowInputField}
                    getNarrativeId={this.state.narrative_id}
                    getProfileData={this.state.profileData}
                    setQuestionAnswersResponse={this.setQuestionAnswersResponse}
                    questionAnswersResponse={this.state.questionAnswersResponse}

                />

                }

                {this.state.next === 4 &&
                <Questions
                    next={this.state.next}
                    prev={this.state.prev}
                    isAddComplain={false}
                    handleNextPrevSteps={this.handleNextPrevSteps}
                    getComplainData={this.state.complainData}
                    setQuestionAnswersData={this.setQuestionAnswersData}
                    setCheckedItems={this.setCheckedItems}
                    checkedItems={this.state.checkedItems}
                    questionAnswersData={this.state.questionAnswersData}
                    isNarrativeUpdate={this.state.isNarrativeUpdate}
                    optionInputFields={this.state.optionInputFields}
                    showInput={this.state.showInput}
                    setOptionInputFields={this.setOptionInputFields}
                    setInputField={this.setShowInputField}
                    getNarrativeId={this.state.narrative_id}
                    getProfileData={this.state.profileData}
                    setQuestionAnswersResponse={this.setQuestionAnswersResponse}
                    questionAnswersResponse={this.state.questionAnswersResponse}

                />
                }
                {this.state.next === 5 &&
                <PatientNarrative
                    setNarrativeSummary={this.setNarrativeSummary}
                    getProfileData={this.state.profileData}
                    handleNextPrevSteps={this.handleNextPrevSteps}
                    getComplainData={this.state.complainData}
                    getComplainLocationData={this.state.complainLocationData}
                    setQuestionAnswersData={this.setQuestionAnswersData}
                    setCheckedItems={this.setCheckedItems}
                    getQuestionAnswersData={this.state.questionAnswersData}
                    isNarrativeUpdate={this.state.isNarrativeUpdate}
                    setIsNarrativeUpdate={this.setIsNarrativeUpdate}
                    setAllComplains={this.setAllComplains}
                    getAllComplains={this.state.allComplains}
                    getPatientId={this.state.patientId}
                    setSelectedComplains={this.setSelectedComplains}
                    addAnotherComplain={this.addAnotherComplain}
                    getNarrativeId={this.state.narrative_id}
                    isModify={true}
                    getNarrativeId={this.state.narrative_id}
                    surgeon_id={this.state.surgeon_id}
                    patientId ={this.state.patientId}

                />
                }
                {this.state.next === 6 &&
                <PatientResponse
                    getNarrativeSummary={this.state.narrativeSummary}
                    getProfileData={this.state.profileData}
                    handleNextPrevSteps={this.handleNextPrevSteps}
                    setResponseData={this.state.setResponseData}
                    getComplainData={this.state.complainData}
                    getComplainLocationData={this.state.complainLocationData}
                    isNarrativeUpdate={this.state.isNarrativeUpdate}
                    getPatientId={this.state.patientId}
                    getNarrativeId={this.state.narrative_id}
                    isModify={true}
                    surgeon_id={this.state.surgeon_id}
                    getPatientAdditionalInfo={this.state.patientAdditionalInfo}
                    getAllComplains={this.state.allComplains}


                />
                }
            </React.Fragment>
        );
    }

    handleNextPrevSteps = (nextStep)=>
    {
        this.setState({
            next:nextStep,
            prev:nextStep-1,
        });
    }
    addAnotherComplain=()=>
    {
        this.setState({
            addAnotherComplain:true
        })
    }
    setProfileData=(data)=>{
        this.setState({
            profileData:data
        });
    }
    setNarrativeId=(id)=>{
        this.setState({
            narrative_id:id
        });
    }
    setComplainData=(data)=>{
        this.setState({
            complainData:data
        });
    }
    setNarrativeSummary=(narrativeSummary)=>{
        let profileData = this.state.profileData;
        profileData['narrative_summary'] = narrativeSummary;
        this.setState({
            profileData:profileData,
            //profileData:profileData
        });

    }

    setComplainLocationData=(data)=>{
        this.setState({
            complainLocationData:data
        });
    }

    setQuestionAnswersData=(data)=>{
        this.setState({
            questionAnswersData:data
        });
    }

    setResponseData=(data)=>{
        this.setState({
            responseData:data
        });
    }

    setIsNarrativeUpdate = (data) =>{
        this.setState({
            isNarrativeUpdate:data
        });
    }

    setCheckedItems = (checkedItems) =>{
        this.setState({ checkedItems: checkedItems});
    }

    setOptionInputFields = (data) =>{
        this.setState({
            optionInputFields:data
        });
    }

    setShowInputField = (data) =>{
        this.setState({
            showInput:data
        });
    }

    getPatientId = () =>
    {
        return this.state.patientId;
    }


    setAllComplains=(complain_prop)=>{

        console.log("Passed Complain Props");
        console.log(complain_prop);

        let found = false;
        let foundIndex;
        for(var i = 0; i < this.state.allComplains.length; i++) {
            if (this.state.allComplains[i].image_and_points[this.state.allComplains[i].image_and_points.length-1].complain_type === complain_prop.image_and_points[complain_prop.image_and_points.length-1].complain_type) {
                found = true;
                foundIndex=i;
                break;
            }
        }

        if(found){
            //    Map
            let filteredArray = this.state.allComplains.map((item,key)=>{

                if(key===foundIndex){

                    return complain_prop;
                }else{
                    return item;
                }

            });

            this.setState({
                allComplains:filteredArray,
                //profileData:profileData
            });

        }else{

            this.setState({
                allComplains:[...this.state.allComplains,complain_prop],
                //profileData:profileData
            });
        }

    }

    setSelectedComplains = (id)=>{
        let _selectedComplains = this.state.selectedComplains;
        _selectedComplains.push(parseInt(id));
        this.setState({
            selectedComplains:_selectedComplains
        })
    }

}
export default SurgeonModifyComplain;